import {
  type WorkplaceCommentsParams,
  type WorkplaceCommentType,
} from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";
import { useQueryClient } from "@tanstack/react-query";

import {
  deletedCommentListCache,
  deletePaginatedCommentListCache,
  deleteSingleCommentCache,
  updateCommentListCache,
  updatePaginatedCommentListCache,
  updateSingleCommentCache,
} from "./queryCache";

interface UseUpdateCachedCommentProps {
  workplaceId: string;
  commentsParams: WorkplaceCommentsParams;
}

export function useUpdateCachedComment(props: UseUpdateCachedCommentProps) {
  const { workplaceId, commentsParams } = props;

  const queryClient = useQueryClient();

  const deleteComment = (commentId: string) => {
    deletedCommentListCache({
      queryClient,
      commentId,
      workplaceId: String(workplaceId),
      commentsParams,
    });

    deletePaginatedCommentListCache({
      workplaceId: String(workplaceId),
      queryClient,
      commentId,
      commentsParams,
    });

    deleteSingleCommentCache({
      commentsParams,
      queryClient,
      commentId,
      workplaceId: String(workplaceId),
    });
  };

  const updateComment = (comment: WorkplaceCommentType) => {
    updateCommentListCache({
      queryClient,
      comment,
      workplaceId: String(workplaceId),
      commentsParams,
    });

    updatePaginatedCommentListCache({
      queryClient,
      comment,
      workplaceId: String(workplaceId),
      commentsParams,
    });

    updateSingleCommentCache({
      queryClient,
      comment,
      workplaceId: String(workplaceId),
      commentsParams,
    });
  };

  return { updateComment, deleteComment };
}
